import { useMemo } from "react";

import { useQueriesTransform } from "lib/react-query/useQueriesTransform";
import { Company } from "prisma/cm/client";

import { usePrismaObjectSync } from "../../store/objectPool/prismaObjectSync";
import {
  UsePosCollectionParams,
  PosQueryIncludeFragment,
} from "../../store/objectPool/prismaObjectSync/queries";

export function useCompanyObject(
  params: UsePosCollectionParams<"Company", PosQueryIncludeFragment<"Company">> = {},
) {
  const companies = usePrismaObjectSync.company.findMany(params);
  return useMemo(() => parseSingletonCompany(companies), [companies]);
}

export function useCompanyQuery(
  params: UsePosCollectionParams<"Company", PosQueryIncludeFragment<"Company">> = {},
) {
  const companies = usePrismaObjectSync.company.findManyAsync(params);
  return useQueriesTransform([companies], parseSingletonCompany);
}

function parseSingletonCompany<T extends Company>(companies: T[] = []) {
  if (companies.length > 1) throw Error("Too many companies.");
  return companies[0];
}

export function useGetCompanyQuery(
  params: UsePosCollectionParams<"Company", PosQueryIncludeFragment<"Company">> = {},
) {
  const getCompaniesQuery = usePrismaObjectSync.company.findManyAsync(params);

  return useQueriesTransform([getCompaniesQuery], parseSingletonCompany);
}

export function useCompanyObjectWithActiveRangeSet() {
  const companies = usePrismaObjectSync.company.findMany({
    include: {
      activeRangeSet: true,
    },
  });
  if (companies.length > 1) throw Error("Too many companies.");
  return useMemo(() => companies[0], [companies]);
}
